// queryありで予約画面を開いた場合の変換処理(出発 or 到着)
export const convertQuerySearchDivision = (stringValue) => {
  if (stringValue == undefined || stringValue == null) {
    return 3;
  } else {
    return stringValue == "departure" ? 3 : 4;
  }
};
